import React, { useContext, useMemo } from "react";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { Text, Tag } from "@foris/avocado-suite";
import { Link } from "@foris/avocado-suite";
import { Label, LabelCategory } from "../../../../../models/ISchema";
import { IContextApp, ContextApp } from "@config/Context/contextApp";
import css from "./tags.module.scss";

interface ITags {
  labels: Label[];
  addMargin?: boolean;
  canEdit?: boolean;
  sectionTitle?: string;
  onEdit?: () => void;
}

const isSystemTag = (label: Label) => label?.category?.labelSource?.code !== "USER-DEFINED";

const Tags: React.FC<ITags> = (props: ITags) => {
  const { labels = [], addMargin, canEdit = true, sectionTitle = "Etiquetas", onEdit } = props;

  const context: IContextApp = useContext(ContextApp);
  const { t } = useTranslation();

  const userCanEdit = context?.user?.permissions?.update && canEdit;
  const labelCategories = useMemo(() => {
    const categories = {};

    labels?.forEach(label => {
      const category = label?.category?.code;

      if (category in categories) {
        categories[category].list.push(label);
      } else {
        categories[category] = { list: [label], category: label?.category };
      }
    });

    return Object.values(categories) as [{ list: Label[]; category: LabelCategory }];
  }, [labels]);

  return (
    <section className={cx(css.cntEditTag, addMargin && css.cntEditTag__addMargin)}>
      <div className={css.cntEditTag_actions}>
        <Text weight="medium" className={css.actionsTitle}>
          {sectionTitle}
        </Text>

        <Link
          size="sm"
          iconLeft={userCanEdit ? "edit" : undefined}
          className={css.actionsLink}
          onClick={() => {
            onEdit?.();
          }}
        >
          {userCanEdit ? t("dimension.package.edit-tag") : t("generals.view-all")}
        </Link>
      </div>

      <section className={cx(css.cntEditTag_contentTags, "container-row")}>
        {labelCategories.map(item => (
          <div key={item.category.code} className={css.tagCategory}>
            <Text weight="medium" className={css.tagCategory_name}>
              {item.category.name}
            </Text>

            <div className={css.tagCategory_labels}>
              {item.list.map(label => (
                <Tag
                  key={label.id}
                  className={cx(css.tagGroup, isSystemTag(label) && css.tagGroup__system)}
                >
                  {!isSystemTag(label) && (
                    <Text type="sm" weight="medium" className={css.tagGroup_code}>
                      {label?.code}
                    </Text>
                  )}
                  <Text type="sm" weight="medium" className={css.tagGroup_name}>
                    {label?.name}
                  </Text>
                </Tag>
              ))}
            </div>
          </div>
        ))}
      </section>
    </section>
  );
};

export default Tags;
